<template>
  <div class="product-detail-tab">
    <div id="desktop-tab">
      <ul class="product-detail-tab-contents">
        <li v-for="(opt, index) in option" :key="index">
          <h4>
            <a
              v-if="opt"
              href="#"
              :class="{ highlight: opt.tabname === config.placeholder }"
              @click.prevent="setNewSelectedOption(opt)"
              >{{ opt.tabname }}</a
            >
          </h4>
        </li>
      </ul>
    </div>
    <div id="mobile-tab" v-load class="product-detail-tab-contents-mobile">
      <vue-dropdown
        :config="config"
        @setSelectedOption="setNewSelectedOption($event)"
      ></vue-dropdown>
    </div>
  </div>
</template>
<script>
import vueDropdown from '../../dropdown/dropdown.vue';
import VueScrollTo from 'vue-scrollto';
import { EventBus } from '../../../mixins/event.js';
export default {
  name: 'mixa-tab-redesign',
  components: {
    vueDropdown,
  },
  props: {
    productName: {
      type: String,
      required: true,
    },
    productSku: {
      type: String,
      required: true,
    },
    option: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      config: {
        options: this.option,
        placeholder: 'DISCOVER',
        backgroundColor: '#068ef3',
        textColor: '#fff',
      },
      currentOption: '',
      isManualSelection: false,
    };
  },
  mounted() {
    EventBus.$on('emittedEvent', (data) => {
      this.findCurrentOption(data);
    });
  },
  beforeDestroy() {
    EventBus.$off('emittedEvent');
  },
  methods: {
    setNewSelectedOption(selectedOption) {
      this.isManualSelection = true;
      this.config.placeholder = selectedOption.tabname;
      if (selectedOption.NavigationID === 'buy-online') {
        window.eventBus.$emit('commerceConnectButtonModal');
      } else {
        window.eventBus.$emit('TabEventDataLayer', selectedOption.tabname);
        VueScrollTo.scrollTo(`#${selectedOption.anchor}`, 500, {
          easing: 'ease',
          offset: -80,
          onDone: () => {
            document.getElementById('desktop-tab').classList.add('desktop-sticky');
            setTimeout(() => {
              this.isManualSelection = false;
            }, 300);
          },
        });
      }
    },
    findCurrentOption(id) {
      if (this.isManualSelection) {
        return;
      }
      this.currentOption = this.config.options.find(function (option) {
        return option.anchor === id;
      });
      this.config.placeholder = this.currentOption.tabname;
      EventBus.$emit('setActiveTabEvent', this.currentOption);
    },
  },
};
</script>
